var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4175 20.7314C4.89448 20.7314 0.41748 16.2544 0.41748 10.7314C0.41748 5.20845 4.89448 0.731445 10.4175 0.731445C15.9405 0.731445 20.4175 5.20845 20.4175 10.7314C20.4175 16.2544 15.9405 20.7314 10.4175 20.7314ZM9.42048 14.7314L16.4905 7.66045L15.0765 6.24645L9.42048 11.9034L6.59148 9.07445L5.17748 10.4884L9.42048 14.7314Z",
    fill: "#3AA64C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenmark);
export default __webpack_public_path__ + "static/media/greenmark.fa42d73c65c03c3dbb19545308ff1204.svg";
export { ForwardRef as ReactComponent };